<template>
  <v-main>
    <!-- snackbar --------------------------------------------------->
    <v-snackbar right top v-model="snackbar.showing" :color="snackbar.color" :timeout="snackbar.timeout">
      <v-icon class="pr-4">{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
    </v-snackbar>
    <!-- snackbar --------------------------------------------------->
    <!-- dialog --------------------------------------------------->
    <v-dialog v-model="dialog.showing" :max-width="dialog.width">
      <v-card>
        <v-toolbar :color="dialog.titlecolor" dark
          >{{ dialog.title }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog.showing = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="body">
          <br />
          {{ dialog.text }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog --------------------------------------------------->
    <!-- dialog Loader--------------------------------------------------->
    <!-- <v-dialog v-model="dialogLoader.showing" persistent width="300"> -->
    <v-dialog v-model="dialogLoader.showing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please wait
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
        <!-- <v-btn color="orange lighten-2" @click="dialogLoader.showing = false"> Hide Overlay </v-btn> -->
      </v-card>
    </v-dialog>
    <!-- dialog Loader--------------------------------------------------->

    <v-slide-x-transition mode="out-in">
      <router-view></router-view>
    </v-slide-x-transition>
  </v-main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Content",
  computed: {
    ...mapState(["snackbar"]),
    ...mapState(["dialog"]),
    ...mapState(["dialogLoader"]),
  },
};
</script>

<style></style>
